import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Main-axis (horizontal) distribution of child columns.
   *
   * @type {String}
   * @storybook-control select
   * @default "start"
   */
  justify: {
    type: String,
    default: "start",
    validator: (value) => ["start", "center", "end", "space-between", "space-around", "space-evenly"].includes(value),
  },
  /**
   * Cross-axis (vertical) alignment of child columns.
   *
   * @type {String}
   * @storybook-control select
   * @default "start"
   */
  align: {
    type: String,
    default: "start",
    validator: (value) => ["start", "center", "end", "baseline", "stretch"].includes(value),
  },
  /**
   * Distribution of wrapped rows along the cross axis when the children break onto multiple lines.
   *
   * @type {String}
   * @storybook-control select
   * @default "start"
   */
  alignContent: {
    type: String,
    default: "start",
    validator: (value) =>
      ["start", "center", "end", "space-between", "space-around", "space-evenly", "stretch"].includes(value),
  },
  /**
   * HTML element used for the row's root — useful when the row represents a semantic region
   * (header, nav, section, etc.).
   *
   * @type {String}
   * @default "div"
   */
  tag: {
    type: String,
    default: "div",
  },
  // FIXME: under unknown circumstances, camelCase props are not reactive
  /**
   * Horizontal gutter between columns. Half of the value is applied as a negative margin on the
   * row to align edge-aligned children with surrounding content.
   *
   * @type {String|Number}
   * @default "var(--sp-comp-row-column-gap, 0.5rem)"
   */
  columngap: {
    type: [String, Number],
    default: "var(--sp-comp-row-column-gap, 0.5rem)",
  },
  // FIXME: under unknown circumstances, camelCase props are not reactive
  /**
   * Vertical gap applied between wrapping rows.
   *
   * @type {String|Number}
   * @default "var(--sp-comp-row-row-gap, 1rem)"
   */
  rowgap: {
    type: [String, Number],
    default: "var(--sp-comp-row-row-gap, 1rem)",
  },
  /**
   * Height of the row. Pass "100%" to fill the parent container.
   *
   * @type {String}
   * @default "auto"
   */
  height: {
    type: String,
    default: "auto",
  },
  /**
   * Remove the inter-column gutter entirely. Equivalent to setting columngap to 0.
   *
   * @type {Boolean|String}
   * @default false
   */
  noGutters: booleanAttribute(),
});
